<template>
  <PopupForm
    title="Assign To Space"
    button="Assign"
    :show="true"
    @close="$emit('close')"
    @confirm="submit"
    :submitting="submitting"
  >
    <div class="input-group col-span-12 sm:col-span-4">
      <span
        v-if="errors.space"
        class="block text-red-600 pb-2"
        >{{ errors.space }}</span
      >
      <ComboBox
        :data="spaces"
        :filter-on="'name'"
        :label="(item) => (item ? `${item.location.name} - ${item.name}` : 'Search for Space')"
        :current-selection="selectedSpace ? spaces.find((space) => space.id === selectedSpace) : null"
        @update="(space) => (selectedSpace = space.id)"
      />
      <span class="text-xs text-gray-600">Minimum 3 characters</span>
    </div>
  </PopupForm>
</template>

<script setup>
import { ref } from 'vue'
import PopupForm from '@/Components/Forms/PopupForm.vue'
import ComboBox from '@/Components/Forms/ComboBox.vue'

const selectedSpace = ref(null)

const emit = defineEmits(['close', 'assign'])

const props = defineProps({
  spaces: {
    type: Array,
    default() {
      return []
    }
  },
  errors: {
    type: Object,
    default() {
      return {}
    }
  },
  submitting: {
    type: Boolean,
    default: false
  }
})

function submit() {
  emit('assign', { spaceId: selectedSpace.value })
}
</script>
